import { useEffect } from 'react'

import { useUnit } from 'effector-react'

import { Page } from '@/components/layout/page/page.tsx'
import { $hasDeleteMediaPermission } from '@/models/permissions.ts'
import { resetSelectedMedia } from '@/models/vault/medias'
import {
  $isCategoryMediaOpen,
  closeVault,
  openVault,
} from '@/models/vault/vault.ts'
import { VaultCategories } from '@/modules/vault/ui/category/vault-categories.tsx'
import { VaultMedia } from '@/modules/vault/ui/media/vault-media.tsx'
import { classNames } from '@/utils/helpers'

export const VaultPage = () => {
  const isCategoryMediaOpen = useUnit($isCategoryMediaOpen)
  const hasDeleteMediaPermission = useUnit($hasDeleteMediaPermission)

  // reset vault state on unmount, so we do not see any selections on messages page
  useEffect(() => {
    openVault()

    return () => {
      // TODO: maybe use `closeVault` and bind those event to it
      closeVault()
      resetSelectedMedia()
    }
  }, [])

  return (
    <div className="h-[calc(100vh-72px)] flex w-full overflow-hidden">
      <Page pageClassName="pb-0 flex-1 overflow-hidden w-full">
        <div className="flex h-full overflow-hidden">
          <div
            className={classNames(
              { hidden: isCategoryMediaOpen },
              'lg:block max-lg:w-full',
            )}
          >
            <VaultCategories
              searchInSort
              contentClassName="!h-full"
            />
          </div>
          <div
            className={classNames(
              { hidden: !isCategoryMediaOpen },
              'w-full lg:flex flex-1 flex overflow-hidden',
            )}
          >
            <VaultMedia
              showMediaActions
              contentClassName="!h-full pb-4"
              hasDeleteMediaPermission={hasDeleteMediaPermission}
            />
          </div>
        </div>
      </Page>
    </div>
  )
}
